import React, { memo } from 'react';

import { Clock } from 'lucide-react';
import { Box, Tooltip } from '@mui/material';

import { getUtcDate } from '@mais-retorno-front/libs/util-helpers';
import { IProps } from './model';

export const LastUpdate = memo<IProps>(
  ({
    lastUpdate,
    text = 'A atualização dos ativos é feita diariamente com as informações disponíveis nas fontes oficiais.',
  }) => {
    if (!lastUpdate) return null;

    return (
      <Box display="flex" justifyContent="flex-end">
        <Tooltip
          title={text}
          data-testid="tooltip"
          placement="left-end"
          enterTouchDelay={100}
          leaveTouchDelay={15000}
        >
          <Box
            component="span"
            width="fit-content"
            display="flex"
            alignItems="center"
            fontSize={13}
            color="#494b56"
            mt={3}
            mb={0}
          >
            <Clock size={15} style={{ marginRight: 5 }} />
            {`Última atualização ${getUtcDate(lastUpdate, 'DD/MM/YYYY')}.`}
          </Box>
        </Tooltip>
      </Box>
    );
  }
);
